import { Link } from 'react-router-dom';
// mantine
import { ActionIcon, Menu, UnstyledButton } from '@mantine/core';
// icons
import {
    AudioLines,
    Ellipsis,
    Link as LinkIcon,
    MessageSquareText
} from 'lucide-react';
// utils
import { getRecordingName } from '@newo/toolkit/bff';
import { downloadFromUrl } from '@newo/toolkit/file';
import type { TRecording } from '@newo/api/gateway';
import { buildURL } from '@newo/toolkit/url';
import { MENU_PORTAL } from '@/constants';

interface ActionsProps {
    sessionId: string;
    contactId: string;
    recordings: TRecording[];
}

const handleClipboardCopy = async (value: string) => {
    await navigator.clipboard.writeText(value);
};

const Actions = ({ sessionId, contactId, recordings }: ActionsProps) => {
    const link = buildURL('/history', {
        session_id: sessionId,
        user_persona_id: contactId
    });
    const fullLink = buildURL(`${globalThis.location.origin}/history`, {
        session_id: sessionId,
        user_persona_id: contactId
    });

    const handleDownload = (recording: TRecording) => {
        downloadFromUrl(recording.play_url, `session_${sessionId}_recording`);
    };

    return (
        <div className="flex items-center gap-4 pr-4">
            <ActionIcon color="blue" component={Link} size="lg" to={link}>
                <MessageSquareText />
            </ActionIcon>
            <Menu
                withinPortal
                portalProps={{ target: `#${MENU_PORTAL}` }}
                shadow="md"
                width={300}
            >
                <Menu.Target>
                    <UnstyledButton>
                        <Ellipsis />
                    </UnstyledButton>
                </Menu.Target>
                <Menu.Dropdown>
                    <Menu.Item
                        leftSection={<LinkIcon />}
                        onClick={async () => handleClipboardCopy(fullLink)}
                    >
                        Copy transcription link
                    </Menu.Item>
                    {recordings.length > 0 && (
                        <>
                            <Menu.Divider />
                            <Menu.Label>Download Recordings</Menu.Label>
                            {recordings.map((recording) => {
                                return (
                                    <Menu.Item
                                        key={recording.play_url}
                                        leftSection={<AudioLines />}
                                        onClick={() => {
                                            handleDownload(recording);
                                        }}
                                    >
                                        {getRecordingName(
                                            'Recording',
                                            recording.duration,
                                            recording.file_size
                                        )}
                                    </Menu.Item>
                                );
                            })}
                        </>
                    )}
                </Menu.Dropdown>
            </Menu>
        </div>
    );
};

export default Actions;
